const NAV_ITEMS = [
  { href: 'https://spas-sky.ru', label: 'HUB' },
  { href: 'https://dash.spas-sky.ru', label: 'REVIEW', active: true },
  { href: 'https://dash.spas-sky.ru/voice/', label: 'VOICE' },
  { href: 'https://dash.spas-sky.ru/plan/', label: 'PLANNER' },
  { href: 'https://dash.spas-sky.ru/gantt/', label: 'GANTT' },
  { href: 'https://ops.spas-sky.ru', label: 'OPSNEXT' },
  { href: 'https://vnc.spas-sky.ru', label: 'VNC' },
];

export function NavBar() {
  return (
    <nav class="topnav">
      {NAV_ITEMS.map((item) => (
        <a
          key={item.label}
          href={item.href}
          class={`topnav-link ${item.active ? 'topnav-active' : ''}`}
        >
          {item.label}
        </a>
      ))}
    </nav>
  );
}
